"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userAssessmentReviewStats = exports.reviewStats = exports.validateGrammarAssessmentReviewPayloadSchema = exports.validatePronunciationAssessmentReviewPayloadSchema = exports.userAssessmentReviewSchema = exports.pronunciationAssessmentReviewCollectionSchema = exports.answerAssessmentReviewCollectionSchema = exports.nativeAssessmentReviewCollectionSchema = exports.grammarAssessmentReviewCollectionSchema = exports.pronunciationAssessmentReviewSchema = exports.answerAssessmentReviewSchema = exports.nativeAssessmentReviewSchema = exports.grammarAssessmentReviewSchema = exports.pronunciationAssessmentReviewPayloadSchema = exports.answerAssessmentReviewPayloadSchema = exports.nativeAssessmentReviewPayloadSchema = exports.grammarAssessmentReviewPayloadSchema = void 0;
const zod_1 = require("zod");
const enums_1 = require("./enums");
const userInteractionAssessment_1 = require("./userInteractionAssessment");
exports.grammarAssessmentReviewPayloadSchema = zod_1.z.object({
    sentence: zod_1.z.string(),
    sentenceCorrected: zod_1.z.string(),
    score: zod_1.z.number(),
    errors: zod_1.z.array(userInteractionAssessment_1.grammarInteractionError.pick({
        originalWord: true,
        correctAudioURL: true,
        correctWord: true,
        replaceStartAt: true,
        replaceEndAt: true,
    })),
});
exports.nativeAssessmentReviewPayloadSchema = userInteractionAssessment_1.userInteractionNativeAssessmentSchema.pick({
    original: true,
    corrected: true,
    explanation: true,
    score: true,
});
exports.answerAssessmentReviewPayloadSchema = userInteractionAssessment_1.userInteractionAnswerAssessmentSchema
    .pick({
    correctAnswer: true,
    userAnswer: true,
    score: true,
})
    .extend({
    options: zod_1.z.array(zod_1.z.string()).nullish(),
    question: zod_1.z.string().nullish(),
});
exports.pronunciationAssessmentReviewPayloadSchema = userInteractionAssessment_1.userInteractionPronunciationAssessmentSchema.pick({
    words: true,
    score: true,
    audioURL: true,
});
const commonAssessmentReviewSchema = zod_1.z.object({
    assessmentReviewId: zod_1.z.string(),
    reviewed: zod_1.z.boolean(),
});
exports.grammarAssessmentReviewSchema = commonAssessmentReviewSchema.extend({
    type: zod_1.z.literal(enums_1.UserInteractionAssessmentType.GRAMMAR),
    payload: exports.grammarAssessmentReviewPayloadSchema,
    revision: exports.grammarAssessmentReviewPayloadSchema.nullish(),
    reviewCount: zod_1.z.number().nullish(),
});
exports.nativeAssessmentReviewSchema = commonAssessmentReviewSchema.extend({
    type: zod_1.z.literal(enums_1.UserInteractionAssessmentType.NATIVE),
    payload: exports.nativeAssessmentReviewPayloadSchema,
});
exports.answerAssessmentReviewSchema = commonAssessmentReviewSchema.extend({
    type: zod_1.z.literal(enums_1.UserInteractionAssessmentType.ANSWER),
    payload: exports.answerAssessmentReviewPayloadSchema,
});
exports.pronunciationAssessmentReviewSchema = commonAssessmentReviewSchema.extend({
    type: zod_1.z.literal(enums_1.UserInteractionAssessmentType.PRONUNCIATION),
    payload: exports.pronunciationAssessmentReviewPayloadSchema,
    revision: exports.pronunciationAssessmentReviewPayloadSchema.nullish(),
    reviewCount: zod_1.z.number().nullish(),
});
exports.grammarAssessmentReviewCollectionSchema = zod_1.z.object({
    type: zod_1.z.literal(enums_1.UserInteractionAssessmentType.GRAMMAR),
    reviews: zod_1.z.array(exports.grammarAssessmentReviewSchema),
});
exports.nativeAssessmentReviewCollectionSchema = zod_1.z.object({
    type: zod_1.z.literal(enums_1.UserInteractionAssessmentType.NATIVE),
    reviews: zod_1.z.array(exports.nativeAssessmentReviewSchema),
});
exports.answerAssessmentReviewCollectionSchema = zod_1.z.object({
    type: zod_1.z.literal(enums_1.UserInteractionAssessmentType.ANSWER),
    reviews: zod_1.z.array(exports.answerAssessmentReviewSchema),
});
exports.pronunciationAssessmentReviewCollectionSchema = zod_1.z.object({
    type: zod_1.z.literal(enums_1.UserInteractionAssessmentType.PRONUNCIATION),
    reviews: zod_1.z.array(exports.pronunciationAssessmentReviewSchema),
});
exports.userAssessmentReviewSchema = zod_1.z.discriminatedUnion("type", [
    exports.grammarAssessmentReviewCollectionSchema,
    exports.nativeAssessmentReviewCollectionSchema,
    exports.answerAssessmentReviewCollectionSchema,
    exports.pronunciationAssessmentReviewCollectionSchema,
]);
exports.validatePronunciationAssessmentReviewPayloadSchema = zod_1.z.object({
    type: zod_1.z.literal(enums_1.UserInteractionAssessmentType.PRONUNCIATION),
    audioURL: zod_1.z.string(),
});
exports.validateGrammarAssessmentReviewPayloadSchema = zod_1.z.object({
    type: zod_1.z.literal(enums_1.UserInteractionAssessmentType.GRAMMAR),
    text: zod_1.z.string().nullish(),
    audioURL: zod_1.z.string().nullish(),
});
exports.reviewStats = zod_1.z.object({
    score: zod_1.z.number(),
    reviews: zod_1.z.number(),
    reviewed: zod_1.z.number(),
});
exports.userAssessmentReviewStats = zod_1.z.object({
    totalScore: zod_1.z.number().nullish(),
    grammar: exports.reviewStats.nullish(),
    native: exports.reviewStats.nullish(),
    answer: exports.reviewStats.nullish(),
    pronunciation: exports.reviewStats.nullish(),
});
//# sourceMappingURL=userAssessmentReview.js.map